import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const createCustomerInvoice = createApiThunk<void, string>(
  "trainingInvoices/createCustomerInvoice",
  async (trainingInvoiceId: string, { extra: { adminRepository } }) => {
    return adminRepository!.createCustomerInvoice(trainingInvoiceId);
  },
);

export const resetCreateCustomerInvoice = createAction("trainingInvoices/resetCreateCustomerInvoice");
